import { JsToClientCommand } from '../jsToClientCommand';
import { ClientCommands } from '../clientCommands';

export type ClientTypeSwitchButtonClickedParams = Record<string, never>;

export class ClientTypeSwitchButtonClickedCommand extends JsToClientCommand<ClientTypeSwitchButtonClickedParams> {
    constructor() {
        super(ClientCommands.CLIENT_TYPE_SWITCH_BUTTON_CLICKED);
    }
}
